/* eslint-disable */
import { api } from '@/services';
import Vuetify from '@/plugins/vuetify';

export default {
  async verificarManutencao({ commit }) {
    const { data } = await api.get('/config/manutencao');
    commit('SET_MANUTENCAO',data.manutencao);
  },
  getLinks() {
    return [
      {
        page: 'Home',
        icon: 'mapa',
        label: Vuetify.framework.lang.t('$vuetify.mapa'),
        hasAtualizacoes: false,
      },
      {
        page: 'AberturaProcesso',
        icon: 'demandas',
        label: Vuetify.framework.lang.t('$vuetify.abrirProcessos'),
        hasAtualizacoes: false,
      },
      {
        page: 'ProcessosKanban',
        icon: 'followUp',
        label: Vuetify.framework.lang.t('$vuetify.followUp'),
        hasAtualizacoes: false,
      },
      {
        page: 'Simulacao',
        icon: 'simulacao',
        label: Vuetify.framework.lang.t('$vuetify.realizarCotacao'),
        hasAtualizacoes: true,
      },
      {
        page: 'AgendamentoRelatorios',
        icon: 'relatorios',
        label: Vuetify.framework.lang.t('$vuetify.enviosEmail'),
        hasAtualizacoes: false,
      },
      {
        icon: 'documentos',
        label: Vuetify.framework.lang.t('$vuetify.documentos'),
        hasAtualizacoes: false,
        group: true,
        childs: [
          {
            page: 'Ged',
            icon: 'documentos',
            label: Vuetify.framework.lang.t('$vuetify.gerais'),
            hasAtualizacoes: false,
          },
          {
            page: 'GestaoLI',
            icon: 'gestaoLi',
            label: Vuetify.framework.lang.t('$vuetify.licencasImportação'),
            hasAtualizacoes: false,
          },
        ],
      },
      {
        icon: 'transporte',
        label: Vuetify.framework.lang.t('$vuetify.transporte'),
        hasAtualizacoes: false,
        group: true,
        childs: [
          {
            page: 'Containers',
            icon: 'container',
            label: Vuetify.framework.lang.t('$vuetify.Containers'),
            hasAtualizacoes: false,
          },
          // Páginas a entrar: FRETES, PERFORMANCE e ANALISE DE FRETE
        ],
      },
      {
        icon: 'armazem',
        label: Vuetify.framework.lang.t('$vuetify.armazenamento'),
        hasAtualizacoes: false,
        group: true,
        childs: [
          {
            page: 'Estoque',
            icon: 'estoque',
            label: Vuetify.framework.lang.t('$vuetify.estoque'),
            hasAtualizacoes: false,
          },
          // Páginas a entrar: ACURACIA ESTOQUE e EFICACIA GERAL
        ],
      },
      {
        icon: 'financeiro',
        label: Vuetify.framework.lang.t('$vuetify.financeiro'),
        hasAtualizacoes: false,
        group: true,
        divider: true,
        childs: [
          {
            page: 'Financeiro',
            icon: 'financeiro',
            label: Vuetify.framework.lang.t('$vuetify.cambio'),
            hasAtualizacoes: false,
          },
          {
            page: 'incentivoFiscal',
            icon: 'incentivoFiscal',
            label: Vuetify.framework.lang.t('$vuetify.incentivoFiscal'),
            hasAtualizacoes: false,
          },
          {
            page: 'crc',
            icon: 'crc',
            label: Vuetify.framework.lang.t('$vuetify.crc'),
            hasAtualizacoes: false,
          },
        ],
      },
      {
        icon: 'base',
        label: Vuetify.framework.lang.t('$vuetify.cadastros'),
        hasAtualizacoes: false,
        group: true,
        childs: [
          {
            page: 'ListarUsuarios',
            icon: 'usuarios',
            label: Vuetify.framework.lang.t('$vuetify.usuarios'),
            hasAtualizacoes: false,
          },
          {
            page: 'cadastrosBasicos',
            icon: 'cadastros',
            label: Vuetify.framework.lang.t('$vuetify.basicos'),
            hasAtualizacoes: true,
          },
          {
            page: 'Empresas',
            icon: 'armazem',
            label: Vuetify.framework.lang.t('$vuetify.empresas'),
            hasAtualizacoes: true,
          },
        ],
      },
      {
        icon: 'interno',
        label: Vuetify.framework.lang.t('$vuetify.interno'),
        hasAtualizacoes: false,
        group: true,
        childs: [
          {
            page: 'processosPendentes',
            icon: 'processosPendentes',
            label: Vuetify.framework.lang.t('$vuetify.processosPendentes'),
            hasAtualizacoes: true,
          },
          {
            page: 'PrevisaoDemandaDomestica',
            icon: 'previsaoDemandaDomestica',
            label: Vuetify.framework.lang.t('$vuetify.demandaDomestica'),
            hasAtualizacoes: true,
          },
          {
            page: 'mercadoHoje',
            icon: 'mercadoHoje',
            label: Vuetify.framework.lang.t('$vuetify.mercadoHoje'),
            hasAtualizacoes: true,
          },
          {
            page: 'Tarefas',
            icon: 'tarefas',
            label: Vuetify.framework.lang.t('$vuetify.tarefasComex'),
            hasAtualizacoes: true,
          },
          {
            page: 'estrategico',
            icon: 'estrategico',
            label: Vuetify.framework.lang.t('$vuetify.estrategico'),
            hasAtualizacoes: false,
          },
        ],
      },
      {
        page: 'processosParceiros',
        icon: 'processosAfiliados',
        label: Vuetify.framework.lang.t('$vuetify.parceiros'),
        hasAtualizacoes: true,
      },
    ];
  },
};
